import { render, staticRenderFns } from "./specification-edit-tab.vue?vue&type=template&id=892983ea&scoped=true"
import script from "./specification-edit-tab.vue?vue&type=script&lang=js"
export * from "./specification-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./specification-edit-tab.vue?vue&type=style&index=0&id=892983ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892983ea",
  null
  
)

export default component.exports